import {
    StrollerProductPhotoState,
    StrollersProductPhotosState,
    initialStrollerProductPhotoState,
    initialStrollersProductPhotosState,
} from "@/mk2/apps/strollers/containers/StrollerProductPhoto/StrollerProductPhoto.reducers";
import { AppState } from "@/mk2/reducers";

export const getStrollerProductPhotoState = (
    state: AppState,
    strollerSlug: string,
): StrollerProductPhotoState =>
    getStrollerProductPhotoPagesState(state).pages[strollerSlug] ||
    initialStrollerProductPhotoState;

export const getStrollerProductPhotoPagesState = (state: AppState): StrollersProductPhotosState =>
    state.containers.strollers.strollersProductPhoto || initialStrollersProductPhotosState;
